import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IProductCategory, ProductCategory } from './ProductCategory'

export class ProductCategoryMapper implements ICollectionMapper<ProductCategory> {
  map(data: IProductCategory): ProductCategory {
    const productCategory = new ProductCategory()
    productCategory.id = data.id
    productCategory.name = data.name
    productCategory.parentId = data.parentId
    productCategory.lineage = data.lineage
    productCategory.hasChildren = data.hasChildren
    return productCategory
  }

  serialize(object: ProductCategory): IProductCategory {
    return JSON.parse(JSON.stringify(object))
  }
}
